module.exports = __webpack_public_path__ + "img/photo-0101.b7bf88d1.jpg";